import React from "react";
import { inject } from "mobx-react";

@inject("modal")
export default class AssignButton extends React.Component {
  assignW = e => {
    e.stopPropagation();
    this.props.modal.modalContentSetter("search_attendee");
    this.props.modal.toggleModal();
    this.props.modal.setSubmitFunction(this.props.assignedUser)
    this.props.modal.parentIdSetter(this.props.id);
    this.props.modal.setAssignedTo(this.props.provider);
  };

  noButton = () => {
    return null;
  };

  showButton = () => {
    if (this.props.assigned) {
      return (
        <div className="assign-btn-wrap">
          <button onClick={this.assignW} className="btn-assign-ws assigned">
            WORKSHOP ASSIGNED
          </button>
        </div>
      );
    } else {
      return (
        <div className="assign-btn-wrap">
          <button onClick={this.assignW} className="btn-assign-ws">
            assign WORKSHOP
          </button>
        </div>
      );
    }
  };

  render() {
    return this.props.admin ? this.showButton() : this.noButton();
  }
}



// WEBPACK FOOTER //
// ./src/blocks/AssignButton.js